export class ArabicHandlerService {
  public static handleArabicLanguage(lang: string) {
    if (lang === 'ar') {
      this.enableRTL();
    } else {
      this.disableRTL();
    }
  }

  private static enableRTL() {
    const head = document.head;
    let link = document.getElementById('rtl-style') as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.id = 'rtl-style';
      link.rel = 'stylesheet';
      link.href = '../../assets/css/styles-rtl.css';
      head.appendChild(link);
    }
  }

  private static disableRTL() {
    const link = document.getElementById('rtl-style');
    if (link) {
      link.remove();
    }
  }
}
